import React, { useEffect, useState } from 'react';

import { Button } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { Calendar } from '@/components';
import cx from './index.module.scss';

interface Props {}

const PageTest: React.FC<Props> = () => {
  const [isCalendarShow, setIsCalendarShow] = useState(false);
  const [date, setDate] = useState(dayjs());
  const [value, setValue] = useState<Dayjs>(null);

  return (
    <div className={cx('page-test')}>
      <div>
        <Button onClick={() => setIsCalendarShow(true)}>显示日历组件</Button>
        <Calendar placeholder="请输入日期" mode="range" onChange={v => setValue(v as Dayjs)} value={value} />
      </div>
    </div>
  );
};

export default PageTest;
